export default __webpack_public_path__ + "static/media/thirdd.01149e8a.png";